export const LEVELS_LABELS = {
  1: 'Федеральное мероприятие',
  2: 'Региональное мероприятие',
  3: 'Муниципальное мероприятие',
  4: 'Локальное мероприятие',
};

export const EVENT_STATUS = {
  ACTIVE: 1,
  DRAFT: 2,
  MODERATE: 3,
  MODERATE_REFUSE: 4,
  CLOSED: 5,
};

export const EVENT_STATUS_CONCEALED = {
  ...EVENT_STATUS,
  TEMPLATE_SUBORDINATED: 10,
  TEMPLATE: 11,
};

export const EVENT_MEMBER_TYPE = {
  SINGLE: 1,
  TEAM: 2,
  MIXED: 3,
};

export const EVENT_MEMBER_TYPE_DATA = {
  [EVENT_MEMBER_TYPE.SINGLE]: {
    text: 'Индивидуальное',
    icon: '$ui-user',
  },
  [EVENT_MEMBER_TYPE.TEAM]: {
    text: 'Командное',
    icon: '$ui-user-group',
  },
  [EVENT_MEMBER_TYPE.MIXED]: {
    text: 'Смешанное',
    icon: '$ui-user-plus',
  },
};

export const EVENT_MEMBER_TYPE_TEXT = {
  [EVENT_MEMBER_TYPE.SINGLE]: 'Индивидуальное',
  [EVENT_MEMBER_TYPE.TEAM]: 'Командное',
  [EVENT_MEMBER_TYPE.MIXED]: 'Смешанное',
};

export const EVENT_USER_STATUS = {
  STATUS_REQUEST: 1,
  STATUS_REJECT: 2,
  STATUS_ACTIVE: 3,
  STATUS_RESTRICTED: 4,
  STATUS_DISQUALIFIED: 5,
  STATUS_DRAFT_REQUEST: 6,
};

export const DEFAULT_NOMINATION = {
  KEY: 'default',
  NAME: 'Основная номинация',
};

export const ALL_NOMINATIONS = 0;

export const SECTION_TYPES = {
  GENERIC: 1, // Секция с карточками или просто заголовок и описание
  TITLE: 2, // Заглавная секция с бэкграундом и ценой
  UNITS: 3, // Секция с темами (программы)
  MAIN: 4, // Заглавная секция с заголовком и картинкой
  ABOUT: 5, // О мероприятии
  NEWS: 6, // Новости
  EXPERTS: 7, // Жюри
  // RESULTS: 8, // Результаты
  GALLERY: 9, // Галерея
  AWARDS: 10, // Награды
  PARTNERS: 11, // Партнеры
  MEMBERS_INFO: 12, // Информация участникам
  VIDEO_PRESENTATION: 13, // Видеопрезентация
  VOTE: 14, // Голосование
  EXHIBITION: 15, // Выставка
  ASSOCIATIONS: 16, // Ассоциации
};

export const SECTION_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
};

/** Тут тело конкретной секции будет подменяться на
 * @/modules/UserEventLanding/components/event-landing/SectionBlocked.vue
 */
export const BLOCKED_SECTIONS = {
  admin_event_template: [
    SECTION_TYPES.TITLE,
    SECTION_TYPES.NEWS,
    SECTION_TYPES.GALLERY,
    SECTION_TYPES.EXPERTS,
    // SECTION_TYPES.RESULTS,
    SECTION_TYPES.AWARDS,
    SECTION_TYPES.VOTE,
    SECTION_TYPES.EXHIBITION,
    SECTION_TYPES.PARTNERS,
  ],
};

export const CARD_TYPES = {
  TOP_AVATAR_SHADOW: 1, // Аватар сверху
  LEFT_AVATAR: 2, // Аватар слева
  QUESTION: 3, // Вопросы
  PROGRESS: 4, // Прогресс
  THEME_LIST: 5, // Список тем
};

export const CARD_TYPES_DATA = {
  [CARD_TYPES.TOP_AVATAR_SHADOW]: {
    key: CARD_TYPES.TOP_AVATAR_SHADOW,
    title: 'Аватар сверху',
  },
  [CARD_TYPES.LEFT_AVATAR]: {
    key: CARD_TYPES.LEFT_AVATAR,
    title: 'Аватар слева',
  },
  [CARD_TYPES.QUESTION]: {
    key: CARD_TYPES.QUESTION,
    title: 'Вопросы и ответы',
  },
  [CARD_TYPES.PROGRESS]: {
    key: CARD_TYPES.PROGRESS,
    title: 'Прогресс',
  },
  [CARD_TYPES.THEME_LIST]: {
    key: CARD_TYPES.THEME_LIST,
    title: 'Список тем',
  },
};

export const SECTION_COMPONENT_TYPE = {
  title: 'title',
  description: 'description',
  list: 'list',
};

export const DEFAULT_PAGE_SECTIONS = [
  {
    active: true,
    data: { enabled: true },
    type: SECTION_TYPES.MAIN,
  },
  {
    active: true,
    data: { enabled: true },
    type: SECTION_TYPES.ABOUT,
  },
  {
    active: true,
    data: { enabled: true },
    type: SECTION_TYPES.UNITS,
  },
  {
    active: true,
    data: { enabled: true },
    type: SECTION_TYPES.MEMBERS_INFO,
  },
  {
    active: true,
    cards: [],
    data: { enabled: false },
    type: SECTION_TYPES.GENERIC,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.EXPERTS,
  },
  // {
  //   active: true,
  //   data: { enabled: false },
  //   type: SECTION_TYPES.RESULTS,
  // },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.VIDEO_PRESENTATION,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.GALLERY,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.EXHIBITION,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.NEWS,
  },
  {
    active: true,
    data: { enabled: true },
    type: SECTION_TYPES.ASSOCIATIONS,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.PARTNERS,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.AWARDS,
  },
  {
    active: true,
    data: { enabled: false },
    type: SECTION_TYPES.VOTE,
  },
];

export const DEFAULT_TEXT_AREA_PROPS = {
  attrs: {
    color: 'redesignBlack',
    'clear-icon': '$iclose',
    rows: 1,
    clearable: true,
    'auto-grow': true,
    'hide-details': true,
    outlined: true,
    dense: true,
  },
  listeners: {},
};

export const CARD_COMPONENT_TYPE = {
  title: 'title',
  description: 'description',
  image: 'image',
};

export const EVENT_STAGE_FORMAT = {
  FULL_TIME: 1,
  PART_TIME: 2,
  REMOTE: 3,
  FULL_PART_TIME: 4,
};

export const EVENT_STAGE_FORMAT_TEXT = {
  [EVENT_STAGE_FORMAT.FULL_TIME]: 'Очный',
  [EVENT_STAGE_FORMAT.PART_TIME]: 'Заочный',
  [EVENT_STAGE_FORMAT.REMOTE]: 'Дистанционный',
  [EVENT_STAGE_FORMAT.FULL_PART_TIME]: 'Очно-заочный',
};

export const EVENT_STAGE_FORMATS_DATA = {
  [EVENT_STAGE_FORMAT.FULL_TIME]: {
    value: EVENT_STAGE_FORMAT.FULL_TIME,
    text: EVENT_STAGE_FORMAT_TEXT[EVENT_STAGE_FORMAT.FULL_TIME],
    description: 'Требуется личное присутствие участников',
    icon: '$igeo',
  },
  [EVENT_STAGE_FORMAT.FULL_PART_TIME]: {
    value: EVENT_STAGE_FORMAT.FULL_PART_TIME,
    text: EVENT_STAGE_FORMAT_TEXT[EVENT_STAGE_FORMAT.FULL_PART_TIME],
    description: 'Личное присутствие участников может потребоваться',
    icon: '$icomputer',
  },
  [EVENT_STAGE_FORMAT.PART_TIME]: {
    value: EVENT_STAGE_FORMAT.PART_TIME,
    text: EVENT_STAGE_FORMAT_TEXT[EVENT_STAGE_FORMAT.PART_TIME],
    description: 'Личное присутствие участников не требуется',
    icon: '$icomputer',
  },
  [EVENT_STAGE_FORMAT.REMOTE]: {
    value: EVENT_STAGE_FORMAT.REMOTE,
    text: EVENT_STAGE_FORMAT_TEXT[EVENT_STAGE_FORMAT.REMOTE],
    description: 'Участие в онлайн-формате',
    icon: '$iweb',
  },
};

export const EVENT_STAGE_FORMATS = [
  EVENT_STAGE_FORMAT.FULL_TIME,
  EVENT_STAGE_FORMAT.FULL_PART_TIME,
  EVENT_STAGE_FORMAT.PART_TIME,
  EVENT_STAGE_FORMAT.REMOTE,
].map((i) => EVENT_STAGE_FORMATS_DATA[i]);

export const EVENT_FRONTEND_PARAMS = {
  IMAGE_OVERLAY: 'image_overlay',
  NOMINATIONS_OVERRIDE: 'nominations_override',
  MANY_EVENT_STAGES: 'many_event_stages',
  EVENT_MANAGES: 'event_managers', // кураторы мероприятия
  EVENT_USER_REQUIREMENTS: 'event_user_requirements',
  POLL_WORK_FILTERS: 'poll_work_filters',
  TOURNAMENT_STAGES_STATE: 'tournament_stages_state',
  INFO_STAGES: 'info_stages',
};

export const DEFAULT_OVERLAY_IMAGE_COLOR = {
  overlay: '#F1F2F6CC',
  text: '#212121',
};

export const EVENT_NOMINATIONS_OVERRIDES = {
  NOMINATIONS: 'nominations',
  SECTIONS: 'sections',
  TRACKS: 'tracks',
  TOPICS: 'topics',
  SITES: 'sites',
  CATEGORIES: 'categories',
  DIRECTIONS: 'directions',
  DISCIPLINES: 'disciplines',
};

export const TOURNAMENT_STAGES_STATES_KEY = {
  unset: 0,
  one: 1,
  many: 2,
};

export const PUBLISH_STATUSES = {
  ACTIVE: 1,
  DELAY_PUBLISH: 2,
  DRAFT: 3,
};

export const VIDEO_HOSTINGS_TYPES = {
  youtube: 1,
  rutube: 2,
  dzen: 3,
  vk: 4,
};

export const VIDEO_HOSTINGS_TEXTS = {
  [VIDEO_HOSTINGS_TYPES.youtube]: 'YouTube',
  [VIDEO_HOSTINGS_TYPES.rutube]: 'RuTube',
  [VIDEO_HOSTINGS_TYPES.dzen]: 'Яндекс Дзен',
  [VIDEO_HOSTINGS_TYPES.vk]: 'VK Видео',
};

export const VIDEO_HOSTINGS_DATA = {
  [VIDEO_HOSTINGS_TYPES.youtube]: {
    value: VIDEO_HOSTINGS_TYPES.youtube,
    text: VIDEO_HOSTINGS_TEXTS[VIDEO_HOSTINGS_TYPES.youtube],
  },
  [VIDEO_HOSTINGS_TYPES.rutube]: {
    value: VIDEO_HOSTINGS_TYPES.rutube,
    text: VIDEO_HOSTINGS_TEXTS[VIDEO_HOSTINGS_TYPES.rutube],
  },
  [VIDEO_HOSTINGS_TYPES.dzen]: {
    value: VIDEO_HOSTINGS_TYPES.dzen,
    text: VIDEO_HOSTINGS_TEXTS[VIDEO_HOSTINGS_TYPES.dzen],
  },
  [VIDEO_HOSTINGS_TYPES.vk]: {
    value: VIDEO_HOSTINGS_TYPES.vk,
    text: VIDEO_HOSTINGS_TEXTS[VIDEO_HOSTINGS_TYPES.vk],
  },
};

export const RESPONSE_MOCK = {
  headers: {
    'x-pagination-total-count': 0,
    'x-pagination-current-page': 1,
    'x-pagination-page-count': 1,
    'x-pagination-per-page': 1,
  },
  data: {
    data: [],
    result_code: 'FLSCS',
  },
};
